export const tr = {
    'default-error': 'Veriler yanlış girildi'
};
